import type { OptionsObject } from 'notistack';

const COMMON_SNACKBAR_MESSAGE_PROPS: OptionsObject = {
    preventDuplicate: false,
    autoHideDuration: 5000,
    anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
    },
};

export const INFO_SNACKBAR_MESSAGE_PROPS: OptionsObject = {
    ...COMMON_SNACKBAR_MESSAGE_PROPS,
    variant: 'info',
};

export const SUCCESS_SNACKBAR_MESSAGE_PROPS: OptionsObject = {
    ...COMMON_SNACKBAR_MESSAGE_PROPS,
    variant: 'success',
};

export const ERROR_SNACKBAR_MESSAGE_PROPS: OptionsObject = {
    ...COMMON_SNACKBAR_MESSAGE_PROPS,
    variant: 'error',
};

export const WARNING_SNACKBAR_MESSAGE_PROPS: OptionsObject = {
    ...COMMON_SNACKBAR_MESSAGE_PROPS,
    variant: 'warning',
};
